import { render } from "./EbookPreview.vue?vue&type=template&id=552e2373&scoped=true"
import script from "./EbookPreview.vue?vue&type=script&lang=js"
export * from "./EbookPreview.vue?vue&type=script&lang=js"

import "./EbookPreview.vue?vue&type=style&index=0&id=552e2373&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552e2373"]])

export default __exports__